import { render, staticRenderFns } from "./Show.vue?vue&type=template&id=38bcb35a&scoped=true"
import script from "./Show.vue?vue&type=script&lang=js"
export * from "./Show.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38bcb35a",
  null
  
)

export default component.exports